import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Design from '@/views/design.vue'
import Home from '@/views/home.vue'
import Login from '@/views/loginAuth.vue'
import Team from '@/views/team/team.vue'
import User from '@/views/user/user.vue'
import PartyUpload from '@/views/partyUpload/partyUpload.vue'
import PartyUploadEdit from '@/views/partyUpload/partyUploadEdit.vue'

import Match from '@/views/match/match.vue'
import { useUserStore } from '@/stores/user'



const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/editor' },
  {
    path: '/home', name: 'Home', component: Home,
    children: [
      { path: '', name: 'TeamHome', component: User },
      { path: 'team', name: 'Team', component: Team },
      { path: 'user', name: 'User', component: User },
    ]
  },
  { path: '/editor', name: 'Editor', component: Design },
  { path: '/loginAuth', name: 'Login', component: Login },
  { path: '/PartyUpload', name: 'PartyUpload', component: PartyUpload },
  { path: '/PartyUploadEdit', name: 'PartyUploadEdit', component: PartyUploadEdit },
  { path: '/match', name: 'Match', component: Match },
  { path: '/:pathMatch(.*)*', redirect: '/editor' }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// router.beforeEach((to, _from, next) => {
//   const userStore = useUserStore()
//   const islogin = userStore.isLoggedIn
//   if (to.path === '/loginAuth' && islogin) {
//     const query: any = { ...to.query }
//     delete query.key
//     query.mode = 'user'
//     next({ name: 'Editor', query, hash: to.hash })
//   }
//   // console.log('paths:', islogin)
//   // console.log('paths:', to.query)
//   next()
// })

export default router